<template>
  <div class="service-project-info app-region blank-t-v blank-b-v blank-l-h blank-r-h"
       v-if="!isScan">
    <a-form-model class="app-form"
                  ref="form"
                  :model="form"
                  :rules="rules"
                  :labelCol="$formLabelCol"
                  :wrapperCol="$formWrapperCol">
      <a-form-model-item label="服务项目名称"
                         prop="name">
        <a-input v-model="form.name"
                 placeholder="请输入服务项目名称"
                 allow-clear></a-input>
      </a-form-model-item>
      <a-form-model-item label="报修项目"
                         prop="project">
        <a-cascader v-model="form.project"
                    :options="projectOptions"
                    placeholder="请选择报修项目"></a-cascader>
      </a-form-model-item>
      <a-form-model-item label="服务项目单价"
                         prop="price">
        <a-input v-model="form.price"
                 placeholder="请输入服务项目单价"
                 allow-clear
                 addon-after="元"></a-input>
      </a-form-model-item>
      <a-form-model-item label="服务项目单位"
                         prop="unit">
        <a-input v-model="form.unit"
                 placeholder="请输入服务项目单位"
                 allow-clear></a-input>
      </a-form-model-item>
      <a-form-model-item label="服务项目图片"
                         prop="avatar">
        <a-upload name="media"
                  :show-upload-list="false"
                  list-type="picture-card"
                  :action="$uploadUrl"
                  class="app-avatar-uploader"
                  :before-upload="$beforeUpload"
                  @change="handleChange">
          <dy-image :src="form.avatar"
                    v-if="form.avatar"
                    preview></dy-image>
          <a-icon :type="avatar.loading ? 'loading' : 'plus'"
                  v-else></a-icon>
        </a-upload>
      </a-form-model-item>
      <a-form-model-item label="服务项目描述"
                         prop="note">
        <a-textarea v-model="form.note"
                    placeholder="请输入服务项目描述"></a-textarea>
      </a-form-model-item>
      <a-form-model-item :wrapper-col="$formEmptyLabelWrapperCol">
        <a-space>
          <a-button type="primary"
                    @click="submit">提交</a-button>
          <a-button @click="cancel">取消</a-button>
        </a-space>
      </a-form-model-item>
    </a-form-model>
  </div>
  <div class="service-project-info"
       v-else>
    <a-descriptions bordered
                    v-viewer>
      <a-descriptions-item label="服务项目名称">{{form.name}}</a-descriptions-item>
      <a-descriptions-item label="报修项目"
                           v-if="projectOptions.filter(val => form.project.indexOf(val.value) > -1).length">{{projectOptions.filter(val => form.project.indexOf(val.value) > -1)[0].children.filter(val => form.project.indexOf(val.repair_items_id) > -1)[0].parentName}}-{{projectOptions.filter(val => form.project.indexOf(val.value) > -1)[0].children.filter(val => form.project.indexOf(val.repair_items_id) > -1)[0].repair_item_name}}</a-descriptions-item>
      <a-descriptions-item label="服务项目单价">{{form.price}}元</a-descriptions-item>
      <a-descriptions-item label="服务项目单位">{{form.unit}}</a-descriptions-item>
      <a-descriptions-item label="服务项目图片">
        <dy-image :src="form.avatar"></dy-image>
      </a-descriptions-item>
      <a-descriptions-item label="服务项目描述">{{form.note}}</a-descriptions-item>
    </a-descriptions>
  </div>
</template>

<script>
import RepairItemsService from '@/io/repair_items.js';
import ServiceProjectService from '@/io/service_project.js';

export default {
  name: 'ServiceProjectInfo',
  props: {
    isScan: {
      type: Boolean,
      default: false
    },
    id: {
      type: Number,
      default () {
        return this.$route.params.id * 1;
      }
    }
  },
  data () {
    return {
      avatar: {
        loading: false
      },
      projectOptions: [],
      form: {
        name: null,
        project: [],
        price: null,
        unit: null,
        avatar: null,
        note: null
      },
      rules: {
        name: [
          {
            required: true,
            message: '请输入服务项目'
          }
        ],
        project: [
          {
            required: true,
            message: '请选择报修项目'
          }
        ],
        price: [
          {
            required: true,
            message: '请输入服务单价'
          }
        ],
        unit: [
          {
            required: true,
            message: '请输入服务单位'
          }
        ],
        avatar: [
          {
            required: true,
            message: '请上传服务图片'
          }
        ],
        note: [
          {
            required: true,
            message: '请填写服务项目描述'
          }
        ],
      }
    }
  },
  watch: {
    id: {
      handler (newValue, oldValue) {
        this.initProject().then(() => {
          this.initPage();
        });
      },
      immediate: true,
    },
  },
  methods: {
    initPage () {
      if (this.id) {
        ServiceProjectService.info(this.id).then(res => {
          this.form.name = res.repair_item_service_name;
          this.$depthSearchTree(node => {
            if (node.value === res.repair_item_id) {
              this.form.project = [node.parentId, res.repair_item_id];
            }
          }, this.projectOptions);
          this.form.price = res.repair_item_price;
          this.form.unit = res.repair_item_unit;
          this.form.avatar = res.repair_item_attachment_id;
          this.form.note = res.repair_item_service_desc;
        }).catch(err => { });
      }
    },
    initProject () {
      let projectOptions = [];
      return RepairItemsService.type().then(res => {
        projectOptions = res.repair_types.map(val => {
          val.label = val.name;
          val.children = [];
          return val;
        }).filter(val => val.value > 1);
        return RepairItemsService.list();
      }).then(res => {
        projectOptions.forEach((value, index) => {
          value.children = res.filter(val => val.repair_item_type === value.value).map(val => {
            val.label = val.repair_item_name;
            val.value = val.repair_items_id;
            val.parentId = value.value;
            val.parentName = value.name;
            return val;
          });
        });
        this.projectOptions = projectOptions.filter(val => val.children.length);
      }).catch(err => { });
    },
    handleChange (info) {
      let status = info.file.status;
      if (status) {
        if (status === 'done') {
          this.avatar.loading = false;
          this.form.avatar = info.file.response.media;
        } else {
          this.avatar.loading = true;
        }
      }
    },
    submit () {
      this.$beforeFormSubmit(this.$refs.form, () => {
        if (this.id) {
          ServiceProjectService.edit(
            this.id,
            this.form.name,
            this.form.project[1],
            this.form.price,
            this.form.unit,
            this.form.avatar,
            this.form.note
          ).then(res => {
            this.$afterFormSubmit('编辑成功', () => {
              this.cancel();
            });
          }).catch(err => { });
        } else {
          ServiceProjectService.add(
            this.form.name,
            this.form.project[1],
            this.form.price,
            this.form.unit,
            this.form.avatar,
            this.form.note
          ).then(res => {
            this.$afterFormSubmit('创建成功', () => {
              this.cancel();
            });
          }).catch(err => { });
        }
      });
    },
    cancel () {
      this.$router.push({
        name: 'ServiceProject'
      });
    }
  },
}
</script>

<style lang="less" scoped>
</style>